import { useWindowSize } from '@velocity/ui'
import { useEffect, useState } from 'react'

import { SCREEN_SIZE } from '../constants/display'

export function useIsMobile() {
  const { innerWidth } = useWindowSize()
  const [isMobile, setIsMobile] = useState(innerWidth < SCREEN_SIZE.MOBILE)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(innerWidth < SCREEN_SIZE.MOBILE)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [innerWidth])

  return isMobile
}
